<template>
  <dnevnik-tabela :podatki="podatki" :nalaganje-tabele="nalaganjeTabele"/>
</template>

<script>
import Vue from 'vue'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'
import DnevnikTabela from './DnevnikTabela.vue'
import LogsService from '../../../../../assets/js/Logs/LogsService.js'
export default {
  name: 'DnevnikAktivnosti',
  mixins: [FormatDatuma],
  components: {DnevnikTabela},
  data () {
    return {
      clientAgent: null,
      logsService: null,
      nalaganjeTabele: false,
      podatki: [],
      izbranIdStranka: '',
      seznamPrikljuckov: ''
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.logsService = new LogsService(this.clientAgent)
    this.getPrikljuckiDovoljenja()
  },
  methods: {
    async getPrikljuckiDovoljenja () {
      try {
        const podatki = await this.clientAgent.makeRequest('permissions/havePermission', { permissionId: 'NAROCNINE' })
        this.setPrikljuckiDovoljenja(podatki)
      } catch (e) {
        this.ShowWarningMessage({message: e.message})
      }
    },
    setPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckov = podatki.permission.additionalData
      if (this.seznamPrikljuckov !== null && this.seznamPrikljuckov.length > 0) {
        this.izbranIdStranka = this.seznamPrikljuckov[0].id_stranka
        this.fetchActivityLog()
      }
    },
    async fetchActivityLog () {
      this.nalaganjeTabele = true
      try {
        const podatki = await this.logsService.fetchActivityLog(this.izbranIdStranka)
        this.setUserData(podatki)
      } catch (e) {
        this.errUserData(e)
      }
    },
    setUserData (podatki) {
      this.podatki = podatki.data.map(item => {
        Vue.set(item, 'formatDatuma', this.PoenotenIzgledDatuma(item.datum.date))
        return item
      })
      this.nalaganjeTabele = false
    },
    errUserData (e) {
      this.ShowWarningMessage({message: e.message})
      this.nalaganjeTabele = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Varnost/DnevnikAktivnosti.vue